import { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { STORE_COMPONENTS } from '@/lib/constants';
import { DropdownPicker } from '../dropdown-picker';

export const DropdownComponents: FC<
  Omit<
    ComponentProps<typeof DropdownPicker>,
    'data' | 'emptyLabel' | 'control' | 'search'
  >
> = (props) => {
  const { t } = useTranslation();

  const components = STORE_COMPONENTS.map((item) => ({
    ...item,
    text: t(`label.components.${item.value}`),
  }));

  return (
    <DropdownPicker
      {...props}
      emptyLabel={t('label.component')}
      data={components}
      control="checkbox"
      search
    />
  );
};
